import { get, post } from '../../api';

export const getComando = (idConfiguracao, id) => {
  return get(`/api/conectores/comando/${idConfiguracao}/${id}`);
};

export const getComandos = (page) => {
  return get(`/api/conectores/comandos/-1?page=${page}`);
};

export const getComandosConector = (idConfiguracao, page) => {
  return get(`/api/conectores/comandos/${idConfiguracao}?page=${page}`);
};

export const postComandos = (data) => {
  return post('/api/conectores/comandos', data);
};
